import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["check"]
  static values = { id: Number }

  async toggle() {
    const taskId = this.idValue
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    try {
      const response = await fetch(`/tasks/${taskId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ task: { status: "completed" }, redirect_to: "mon_jour" })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error("[TaskComplete] Error:", error)
    }
  }
}
